import { InjectionToken } from '@angular/core';

export const customerSupport = {
  schedule1: '9.00 a 20.00',
  schedule2: '16.00 a 18.00',
  schedule3: '9.00 a 15.00',
  phone: '91 271 30 60',
  mail: 'atencion.clientes@renaultbank.com',
};

export type CustomerSupport = typeof customerSupport;

export const CUSTOMER_SUPPORT = new InjectionToken('CUSTOMER_SUPPORT', {
  providedIn: 'root',
  factory: () => customerSupport,
});
